import DefaultWorklist from '../../enums/DefaultWorklist';

export default {
  namespaced: true,
  state() {
    return {
      id: null,
      name: null,
      projectId: [],

      builtin: false,
    };
  },

  mutations: {
    setWorklist(state, worklist) {
      state.id = worklist.id;
      state.name = worklist.name;
      state.builtin = false;
    },
    setDefaultWorklist(state, worklist) {
      state.id = worklist.id;
      state.name = DefaultWorklist[worklist.id];
      state.builtin = true;
    }
  },
  
  getters: {
    getCurrentWorklist: (state) => {
      return {
        id: state.id,
        name: state.name,
        projectId: state.projectId,
        builtin: state.builtin,
      };
    }
  }
};
